<template>
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-plus">
    <rect x="6.66016" y="12.2495" width="13.5" height="1.5" rx="0.75" fill="#003413" />
    <rect x="14.1602" y="6.25" width="13.5" height="1.5" rx="0.75" transform="rotate(90 14.1602 6.25)" fill="#003413" />
  </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.icon-plus {
  display: block;
  rect {
    fill: var(--theme-colors-denary);
  }
}
</style>
